import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const createWellness = createAsyncThunk(
  "api/fetchData",
  async (userData, { rejectWithValue }) => {
    let config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    };
    try {
      const response = await axios.post(
        `${API_BASE_URL}/wellness-events`,

        userData,
        config
      );
      let status = "success";
      let data = {
        status: status,
        message: response,
      };
      return data;
    } catch (error) {
      let status = "error";
      let data = {
        status: status,
        message:
          error.response?.data || "Something went wrong, please try again.",
      };
      return data;
    }
  }
);

const createWellnessSlice = createSlice({
  name: "api",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createWellness.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createWellness.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(createWellness.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default createWellnessSlice.reducer;
